export * from "ce/utils/AnalyticsUtil";
import * as CE_AnalyticsUtil from "ce/utils/AnalyticsUtil";

export default CE_AnalyticsUtil;
